import {
  destroyAdmin,
  getAdmin,
  postAdminForm,
  putAdminForm,
} from "../axios/api/AdminBaseUrl";
import { buildQueryString } from "../utils/queryParams";

export const user = {
  list: {
    key: "list",
    call: (page, search, statusFilter, type, ordering) => {
      const query = buildQueryString({
        page,
        search,
        status: statusFilter,
        user_type: type,
        ordering,
      });
      return getAdmin(`/admin/user/?${query}`);
    },
  },
  details: {
    key: "details",
    call: (id) => {
      return getAdmin(`/admin/user/${id}/`);
    },
  },
  delete: {
    key: "delete",
    call: (id, permanent = false) => {
      const query = permanent ? "?permanent=true" : "";
      return destroyAdmin(`/admin/user/${id}/${query}`);
    },
  },
  role: {
    key: "role",
    call: () => {
      return getAdmin(`/role_dropdown/`);
    },
  },
  add: {
    key: "add",
    call: (payload) => {
      return postAdminForm(`/admin/user/`, payload);
    },
  },
  update: {
    key: "update",
    call: (userId, payload) => {
      return putAdminForm(`/admin/user/${userId}/`, payload);
    },
  },
};
